import moment from "moment";
import {
  SIGNIN_INIT,
  SIGNIN_SUCCESS,
  SIGNOUT_SUCCESS,
  SET_BALANCE,
} from "../_types";
import { cf, hp } from "../../utils";

const token = hp.getCookie("user_token") || "";
const account = hp.safeParseJSON(hp.getCookie("active_account"), {});

const accountCountry =
  account.organizationCountry || account.country || account.signup_country;

let user = {};
let canAccessVoice = true;
let canAccessMarketPrice = false;
let canAccessWeather = false;

if (hp.getCookie("user")) {
  user = hp.safeParseJSON(hp.getCookie("user"), {});
  user["currency"] =
    user.country || user.signup_country
      ? (user.country || user.signup_country).toLowerCase() === "ghana"
        ? "GHS"
        : "USD"
      : "USD";
  const timeZ = hp.getTimeZone(user.country);
  const timeZone = moment.tz(timeZ).format("Z");
  user["timeZone"] = timeZone;
  const projectId = hp.getCookie("project_id");
  // canAccessVoice = hp.checkAccess({
  //   access: cf.REACT_APP_VOICE_ACCESS,
  //   projectId,
  //   country: accountCountry.toLowerCase(),
  // });
  console.log("user in permission check", user);

  // canAccessMarketPrice = hp.checkAccess({
  //   access: process.env.REACT_APP_ACCESS_PRICES,
  //   projectId,
  //   country: accountCountry.toLowerCase(),
  // });
  canAccessMarketPrice = hp.hasPAccess({
    permission: "ACCESS_PRICES",
    accountId: account.id,
    projectId,
  });
  // canAccessWeather = hp.checkAccess({
  //   access: process.env.REACT_APP_ACCESS_WEATHER,
  //   projectId,
  //   country: accountCountry.toLowerCase(),
  // });
  canAccessWeather = hp.hasPAccess({
    permission: "ACCESS_WEATHER",
    accountId: account.id,
    projectId,
  });
}
account["currency"] = accountCountry
  ? accountCountry.toLowerCase() === "ghana"
    ? "GHS"
    : "USD"
  : "USD";

const initialState = {
  user,
  account,
  token,
  authenticated: token ? true : false,
  balance: 0,
  signingIn: false,
  canAccessVoice,
  canAccessMarketPrice,
  canAccessWeather,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;

    case SIGNIN_INIT:
      return {
        ...state,
        signingIn: action.payload,
      };

    case SIGNIN_SUCCESS:
      action.payload.data.user["currency"] =
        action.payload.data.user["currency"] || "GHS";
      action.payload.data.account["currency"] =
        action.payload.data.account["currency"] || "GHS";

      return {
        ...state,
        authenticated: true,
        token: action.payload.token,
        user: action.payload.data.user,
        account: action.payload.data.account,
      };

    case SIGNOUT_SUCCESS:
      return {
        ...state,
        user: {},
        token: "",
        authenticated: false,
      };

    case SET_BALANCE:
      return {
        ...state,
        balance: action.payload,
      };
  }
};

export default authReducer;
